import React, { useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

type FlashMessageProps = {
  type?: 'error' | 'notice' | 'info';
  className?: string;
  message: NonNullable<React.ReactNode>;
};

function FlashMessage({ message, className = '', type = 'info' }: FlashMessageProps) {
  const icon: IconProp = useMemo(() => {
    switch (type) {
      case 'error':
      case 'notice':
        return 'exclamation-circle';
      case 'info':
        return 'info-circle';
    }
  }, [type]);

  return (
    <div
      className={`flash-message flash-${type} ${className}`}
      role={type === 'error' ? 'alert' : 'none'}
    >
      <p>
        <FontAwesomeIcon icon={icon} /> {message}
      </p>
    </div>
  );
}

export default FlashMessage;
